import { createFileRoute } from '@tanstack/react-router';
import { CostsPage } from '@/features/settings/costs/CostsPage';
import { COSTS_SEARCH_DEFAULTS, CostsSearch, stripDefaults } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/settings/costs')({
  validateSearch: CostsSearch,
  search: { middlewares: [stripDefaults(CostsSearch, COSTS_SEARCH_DEFAULTS)] },
  component: CostsPage,
});
